import React from 'react'
import * as R from 'ramda'

export const useModal = ({ isInitiallyToggled = false } = {}) => {
  const [isOpen, setIsOpen] = React.useState(isInitiallyToggled)

  const handleClose = React.useCallback(() => setIsOpen(R.F), [setIsOpen])

  const handleOpen = React.useCallback(() => setIsOpen(R.T), [setIsOpen])

  return {
    isOpen,
    handleClose,
    handleOpen,
  }
}
